var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConctAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.39 13.7L10.51 15.58L11.58 16.64C11.68 16.75 11.74 16.9 11.74 17.06C11.74 17.22 11.68 17.36 11.58 17.47L10.64 18.41C10.53 18.52 10.38 18.58 10.22 18.58C10.07 18.58 9.92 18.52 9.81 18.41L9.59 18.19C9.52 18.28 9.45 18.37 9.37 18.45L6.64 21.18C6.3 21.51 5.85 21.71 5.37 21.71C4.89 21.71 4.42 21.51 4.08 21.18L2.92 20.15L1.77 21.38C1.56 21.58 1.3 21.68 1.04 21.68C0.78 21.68 0.51 21.58 0.32 21.38C-0.08 20.98 -0.08 20.33 0.32 19.93L1.48 18.7L0.53 17.63C0.19 17.28 0 16.83 0 16.34C0 15.85 0.19 15.41 0.53 15.06L3.25 12.34C3.34 12.25 3.42 12.18 3.52 12.12L3.3 11.9C3.07 11.67 3.07 11.3 3.3 11.07L4.23 10.13C4.34 10.02 4.49 9.96999 4.65 9.96999C4.81 9.96999 4.95 10.02 5.06 10.13L6.13 11.2L8.01 9.31999C8.12 9.20999 8.26 9.14999 8.42 9.14999C8.57 9.14999 8.72 9.20999 8.83 9.31999L9.48 9.97999C9.71 10.2 9.71 10.57 9.48 10.8L7.61 12.67L9.03 14.1L10.91 12.23C11.02 12.11 11.17 12.06 11.32 12.06C11.47 12.06 11.62 12.11 11.74 12.23L12.39 12.88C12.61 13.1 12.61 13.47 12.39 13.7Z",
    fill: "url(#paint0_linear_21_408)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.13 4.14C21.47 4.47 21.66 4.93 21.66 5.41C21.66 5.89 21.47 6.35 21.13 6.69L18.4 9.42C18.32 9.5 18.23 9.58 18.13 9.64L18.36 9.86C18.59 10.09 18.59 10.46 18.36 10.69L17.42 11.62C17.31 11.73 17.17 11.8 17.01 11.8C16.85 11.8 16.7 11.73 16.59 11.62L10.08 5.11C9.96997 5 9.90997 4.85 9.90997 4.7C9.90997 4.55 9.96997 4.4 10.08 4.29L11.02 3.35C11.13 3.23 11.28 3.18 11.43 3.18C11.59 3.18 11.73 3.23 11.85 3.35L12.07 3.57C12.13 3.48 12.2 3.39 12.28 3.31L15.01 0.58C15.35 0.24 15.81 0.05 16.29 0.05C16.77 0.05 17.23 0.24 17.57 0.58L18.62 1.63L20.04 0.3C20.44 -0.1 21.09 -0.1 21.49 0.3C21.89 0.7 21.89 1.36 21.49 1.75L20.07 3.08L21.13 4.14Z",
    fill: "url(#paint1_linear_21_408)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_408",
    x1: 0,
    y1: 15.43,
    x2: 12.55,
    y2: 15.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_408",
    x1: 9.90997,
    y1: 5.9,
    x2: 21.79,
    y2: 5.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.79,
    height: 21.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConctAct1);
export default __webpack_public_path__ + "static/media/ConctAct_1.10ea888e847aca995d40cd57885e5986.svg";
export { ForwardRef as ReactComponent };